import React from 'react';
import { Modal } from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";
import Button from '../../elements/CustomButton/CustomButton.jsx';
import FormInputs from '../../components/FormInputs/FormInputs.jsx';
import { getTable } from '../Components/JQueryTable/JQueryTableLogic';
import AlertError from '../Components/AlertError.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper';

class CreateConvocatoria extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      fields: {},
      fieldError: {},
      file: null,
      isEdit: this.props.number !== 0,
      total: null,
      alert: null,
    }
    this.handleOnChange = this.handleOnChange.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
    this._uploadFile = this._uploadFile.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.getAnnouncement = this.getAnnouncement.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }
  componentWillMount() {
    // Validaciones iniciales de campos requeridos en caso de create
    if (!this.state.isEdit) {
      const camposRequeridos = ['numero', 'inicio', 'fin'];
      const auxStateToSet = {};
      camposRequeridos.forEach((campo) =>{
        auxStateToSet[campo] = {};
        auxStateToSet[campo].error = true;
        auxStateToSet[campo].message = (
          <small className="text-danger">
            Campo requerido!
          </small>);
      });
      this.setState({ fieldError: auxStateToSet });
    }
  }
  componentDidMount() {
    this.getAnnouncement(this.props.number);
  }
  getAnnouncement(number) {
    this.props.incubationService
      .getAnnouncement(number)
      .then(res => {
        const auxFields = {
          numero: res.announcement.numero,
          inicio: res.announcement.fechainicio,
          fin: res.announcement.fechafin,
        };
        this.setState({
          fields: auxFields,
          total: res.announcement.total,
        });
        //this.drawTabs(res.contacts);
      })
      .catch(err => {
        console.log(err);
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se obtenia la información de la convocatoria, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <AlertError hideAlert={this.hideAlert} message={message} />
      )
    });
  }
  handleOnChange(event, name) {
    const auxState = this.state.fields;
    auxState[name] = event.target.value;
    this.setState({ fields: auxState });
    this.validateInput(event.target.value, name);
  }
  validateInput(value, name) {
    const auxFieldError = this.state.fieldError;
    auxFieldError[name] = {};

    if (value === '' || null || undefined) {
      auxFieldError[name].error = true;
      auxFieldError[name].message = (
        <small className="text-danger">
          Campo requerido!
        </small>);
      this.setState({ fieldError: auxFieldError })
    } else if (name === 'numero') {
      const regNumber = /^\d+$/;
      if (regNumber.test(value) || value === '') {
        auxFieldError[name].error = false;
        this.setState({ fieldError: auxFieldError });
      } else {
        auxFieldError[name].error = true;
        auxFieldError[name].message = (
          <small className="text-danger">
            Valor incorrecto! Ingrese solo números.
          </small>);
        this.setState({ fieldError: auxFieldError });
      }
    } else {
      auxFieldError[name].error = false;
      this.setState({ fieldError: auxFieldError });
    }

  }
  checkErrors() {
    const aux = this.state.fieldError;
    let error = false;
    Object.keys(aux).forEach((key, index) => { // Iterar en el objecto buscando errores true.
      if (aux[key].error) {
        error = true;
      }
    });
    return error;
  }
  hideAlert() {
    this.setState({ alert: null });
  }
  onContinue() {
    this.hideAlert();
    this.uploadInput.click();
  }
  _uploadFile() {
    if (this.state.total > 0) {
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Precaución!"
            onConfirm={() => this.onContinue()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Continuar"
            cancelBtnText="Cancelar"
            showCancel
          >
            Subir un nuevo archivo a esta convocatoria causará que las postulaciones sean eliminadas IRREVERSIBLEMENTE!
            <p>Total de postulaciones que serán eliminadas: {this.state.total}</p>
            <small>Desea continuar de todas formas?</small>
          </SweetAlert>
        )
      });
    } else {
      this.uploadInput.click();
    }
  }
  handleFileChange(e) {
    e.preventDefault();
    this.setState({ file: this.uploadInput.files[0] });
  }

  refreshTables() {
    const tableConv = getTable("convocatoria");
    tableConv.clear();
    tableConv.ajax.reload();
    tableConv.draw();
    const tableIdea = getTable("idea");
    tableIdea.clear();
    tableIdea.ajax.reload();
    tableIdea.draw();
    const tablePreInc = getTable("preIncubationTab");
    tablePreInc.clear();
    tablePreInc.ajax.reload();
    tablePreInc.draw();
    const tableInc = getTable("incubationTab");
    tableInc.clear();
    tableInc.ajax.reload();
    tableInc.draw();
  }

  onSave(){
      this.props.incubationService
        .createAnnouncement(
          this.state.fields.numero,
          this.state.fields.inicio,
          this.state.fields.fin,
          this.state.file,
        )
        .then(res => {
          this.props.jumpToConvocatoriaTab(); // Volver al tab de Convocatoria despues de crear una nueva en caso de estar en otra tab
          this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Convocatoria guardada satisfactoriamente!</div>), 10);
          this.props.closeCreateModal();
          this.props.getConvocatorias();
          this.refreshTables();
        })
        .catch(err => {
          this.props.setError((<div>Ha ocurrido un error mientras se actualizaban los datos de la convocatoria, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
        });

  }
  render() {
    const disabledButton = this.checkErrors(); // Deshabilitar boton de guardado si hay errores en los campos
    return(
      <span>
        {this.state.alert}
        <Modal show onHide={() => this.props.closeCreateModal()} style={{ display: "block", marginTop: "200px" }}>
          <ModalBlockWrapper
            content={
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>{this.state.isEdit ? 'Editar convocatoria' : 'Crear nueva convocatoria'}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto'}}>
                  <FormInputs
                    ncols = {['col-md-6', 'col-md-6']}
                    properties = {[
                      {
                        label : 'Inicio',
                        type : 'date',
                        bsClass : "form-control",
                        value : this.state.fields.inicio ? this.state.fields.inicio : '',
                        disabled : false,
                        name: 'inicio',
                        onChange : this.handleOnChange,
                        error: this.state.fieldError.hasOwnProperty('inicio') && this.state.fieldError['inicio'],
                      },
                      {
                        label : 'Fin',
                        type : 'date',
                        bsClass : "form-control",
                        value : this.state.fields.fin ? this.state.fields.fin : '',
                        disabled : false,
                        name: 'fin',
                        onChange : this.handleOnChange,
                        error: this.state.fieldError.hasOwnProperty('fin') && this.state.fieldError['fin'],
                      },
                    ]}
                  />
                  <FormInputs
                    ncols = {['col-md-6', 'col-md-6']}
                    properties = {[
                      {
                        label : 'Número',
                        type : 'text',
                        bsClass : "form-control",
                        value : this.state.fields.numero ? this.state.fields.numero : '',
                        disabled : false,
                        name: 'numero',
                        onChange : this.handleOnChange,
                        error: this.state.fieldError.hasOwnProperty('numero') && this.state.fieldError['numero'],
                      },
                      {
                        label : 'Archivo',
                        type : 'text',
                        bsClass : "form-control",
                        value: this.state.file ? this.state.file.name : 'No se seleccionó ningún archivo..',
                        disabled : true,
                        name: 'archivo',
                        error: false,
                      }
                    ]}
                  />
                  <span style={{ float: 'left' }}>
                    <input accept=".csv" ref={(ref) => { this.uploadInput = ref; }} type="file" style={{'visibility': 'hidden'}} onChange={this.handleFileChange} />
                  </span>
                  <span style={{ float: 'right' }}>
                    <Button onClick={this._uploadFile} bsStyle="primary" fill={true}>Agregar archivo</Button>
                    <Button disabled={!this.state.file} onClick={() => this.setState({ file: null })} bsStyle="danger" fill={true}>
                      <i className="fa fa-ban"></i>
                    </Button>
                  </span>
                </Modal.Body>
                <Modal.Footer>
                  <span title={disabledButton ? 'Uno o mas campos contienen errores!' : null}>
                    <Button onClick={this.onSave} disabled={disabledButton}>Guardar</Button>
                  </span>
                </Modal.Footer>
              </div>
            }
          />
        </Modal>
      </span>
    );
  }
}

export default CreateConvocatoria;



// WEBPACK FOOTER //
// ./src/views/Incubation/CreateConvocatoria.jsx